// 专门给 educator 使用的工具路由（使用统一前缀）
const prefix = "educator";

export const toolRoutes = [
  {
    name: `${prefix}-chat`,
    path: "chat",
    meta: { title: "创作中心" },
    component: () => import("@/views/ChatNew.vue"),
  },
  {
    name: `${prefix}-chat-id`,
    path: "chat/:id",
    meta: { title: "创作中心" },
    component: () => import("@/views/ChatNew.vue"),
  },

  // 图片工具
  {
    name: `${prefix}-image-recognize`,
    path: "tool/image-recognize",
    meta: { title: "图像识别" },
    component: () => import("@/views/tools/image/ImageRecognize.vue"),
  },
  {
    name: `${prefix}-image-tagging`,
    path: "tool/image-tagging",
    meta: { title: "图像识别置信度" },
    component: () => import("@/views/tools/image/ImageTagging.vue"),
  },
  {
    name: `${prefix}-image-digital`,
    path: "tool/image-digital",
    meta: { title: "图像数字化实验室" },
    component: () => import("@/views/tools/image/Digitalization.vue"),
  },
  {
    name: `${prefix}-text-ocr`,
    path: "tool/text-ocr",
    meta: { title: "OCR文本识别" },
    component: () => import("@/views/tools/text/TextOcr.vue"),
  },
  {
    name: `${prefix}-handwrite`,
    path: "tool/handwrite",
    meta: { title: "手写识别" },
    component: () => import("@/views/tools/text/Handwrite.vue"),
  },
  {
    name: `${prefix}-text-classify`,
    path: "tool/text-classify",
    meta: { title: "文本分类" },
    component: () => import("@/views/tools/text/TextClassify.vue"),
  },
  {
    name: `${prefix}-text-segment`,
    path: "tool/text-segment",
    meta: { title: "文本分词" },
    component: () => import("@/views/tools/text/TextSegment.vue"),
  },
  {
    name: `${prefix}-face-express`,
    path: "tool/face-express",
    meta: { title: "人脸表情识别" },
    component: () => import("@/views/tools/misc/FaceExpress.vue"),
  },
  {
    name: `${prefix}-face-compare`,
    path: "tool/face-compare",
    meta: { title: "人脸对比" },
    component: () => import("@/views/tools/misc/FaceCompare.vue"),
  },
  {
    name: `${prefix}-image`,
    path: "tool/image",
    meta: { title: "文生图" },
    component: () => import("@/views/tools/image/ImageGeneration.vue"),
  },
  {
    name: `${prefix}-future-me`,
    path: "tool/future-me",
    meta: { title: "未来的我" },
    component: () => import("@/views/tools/image/FutureMe.vue"),
  },

  // 训练工具
  {
    name: `${prefix}-train-image`,
    path: "tool/train-image",
    meta: { title: "图像训练" },
    component: () => import("@/views/tools/training/TrainImage.vue"),
  },
  {
    name: `${prefix}-train-pose`,
    path: "tool/train-pose",
    meta: { title: "姿势训练" },
    component: () => import("@/views/tools/training/TrainPose.vue"),
  },
  {
    name: `${prefix}-train-audio`,
    path: "tool/train-audio",
    meta: { title: "音频训练" },
    component: () => import("@/views/tools/training/TrainAudio.vue"),
  },
  {
    name: `${prefix}-train-text`,
    path: "tool/train-text",
    meta: { title: "文本训练" },
    component: () => import("@/views/tools/training/TrainText.vue"),
  },

  // 思维工具
  {
    name: `${prefix}-markmap`,
    path: "tool/markmap",
    meta: { title: "AI脑图" },
    component: () => import("@/views/tools/misc/MarkMap.vue"),
  },
  {
    name: `${prefix}-quickdraw`,
    path: "tool/quickdraw",
    meta: { title: "你画AI猜" },
    component: () => import("@/views/tools/image/QuickDraw.vue"),
  },
  {
    name: `${prefix}-quickdrawty`,
    path: "tool/quickdrawty",
    meta: { title: "涂鸦识别" },
    component: () => import("@/views/tools/image/QuickDrawTy.vue"),
  },
  // 语音工具
  {
    name: `${prefix}-tts`,
    path: "tool/tts",
    meta: { title: "语音合成" },
    component: () => import("@/views/tools/audio/DoubaoTTS.vue"),
  },
  {
    name: `${prefix}-asryy`,
    path: "tool/asryy",
    meta: { title: "语音识别" },
    component: () => import("@/views/tools/audio/FunAsrRealtimeyy.vue"),
  },
  {
    name: `${prefix}-asrfy`,
    path: "tool/asrfy",
    meta: { title: "方言识别" },
    component: () => import("@/views/tools/audio/FunAsrRealtimefy.vue"),
  },
  // {
  //   name: `${prefix}-asryz`,
  //   path: "tool/asryz",
  //   meta: { title: "声音可视化" },
  //   component: () => import("@/views/tools/audio/Waveform.vue"),
  // },

  {
    name: `${prefix}-realtime`,
    path: "tool/realtime",
    meta: { title: "智能语音助手" },
    component: () => import("@/views/tools/audio/DoubaoRealtime.vue"),
  },
  {
    name: `${prefix}-voice-clone`,
    path: "tool/voice-clone",
    meta: { title: "声音克隆" },
    component: () => import("@/views/tools/audio/VoiceClone.vue"),
  },
  {
    name: `${prefix}-audio-visualizer`,
    path: "tool/audio-visualizer",
    meta: { title: "声音可视化" },
    component: () => import("@/views/tools/audio/AudioVisualizer.vue"),
  },
  {
    name: `${prefix}-sound-lab`,
    path: "tool/sound-lab",
    meta: { title: "声学实验室" },
    component: () => import("@/views/tools/audio/SoundLab.vue"),
  },
  {
    name: `${prefix}-wake-lab`,
    path: "tool/wake-lab",
    meta: { title: "唤醒实验室" },
    component: () => import("@/views/tools/audio/WakeLab.vue"),
  },
  {
    name: `${prefix}-voiceprint`,
    path: "tool/voiceprint",
    meta: { title: "声纹密码" },
    component: () => import("@/views/tools/audio/VoicePrint.vue"),
  },

  // 视频工具
  {
    name: `${prefix}-video`,
    path: "tool/video",
    meta: { title: "视频生成" },
    component: () => import("@/views/tools/video/VideoGeneration.vue"),
  },

  // 音乐工具
  {
    name: `${prefix}-music`,
    path: "tool/music",
    meta: { title: "音乐生成" },
    component: () => import("@/views/tools/music/MusicGeneration.vue"),
  },

  {
    name: `${prefix}-jupyter`,
    path: "tool/jupyter",
    meta: { title: "Jupyter" },
    component: () => import("@/views/tools/misc/JupyterHub.vue"),
  },
  {
    name: `${prefix}-vibe-coding`,
    path: "tool/vibe-coding",
    meta: { title: "氛围编程" },
    component: () => import("@/views/tools/code/VibeCoding.vue"),
  },

  // 游戏工具
  {
    name: `${prefix}-gomoku`,
    path: "tool/gomoku",
    meta: { title: "AI五子棋" },
    component: () => import("@/views/tools/game/Gomoku.vue"),
  },
  {
    name: `${prefix}-sokoban`,
    path: "tool/sokoban",
    meta: { title: "语音推箱子" },
    component: () => import("@/views/tools/game/Sokoban.vue"),
  },
];

// 教师路由配置
export const educatorRoutes = [
  {
    path: "/educator/login",
    name: "educator-login",
    meta: { title: "教师登录" },
    component: () => import("@/views/educator/EducatorLogin.vue"),
  },
  {
    path: "/educator/register",
    name: "educator-register",
    meta: { title: "教师注册" },
    component: () => import("@/views/educator/EducatorRegister.vue"),
  },
  // 独立布局的授课工具页面
  {
    path: "/educator/teachingtool",
    name: "educator-teaching-tool",
    meta: { title: "授课工具" },
    component: () => import("@/views/educator/TeachingTool.vue"),
  },
  // {
  //   path: "/educator",
  //   name: "educator-nav",
  //   meta: { title: "海牛AI实验室" },
  //   component: () => import("@/views/educator/EducatorNav.vue"),
  // },
  {
    path: "/educator",
    name: "educator-home",
    redirect: "/educator/room",
    component: () => import("@/views/educator/EducatorHome.vue"),
    meta: {
      title: "海牛AI教师控制台",
      requiresAuth: true,
      roles: ["educator"],
    },
    children: [
      ...toolRoutes,

      {
        path: "tool",
        name: "educator-ai-tool",
        meta: { title: "AI工具" },
        component: () => import("@/views/educator/MyTools.vue"),
      },
      {
        path: "room",
        name: "educator-room",
        meta: { title: "班级管理" },
        component: () => import("@/views/educator/room/RoomList.vue"),
      },
      {
        path: "room/add",
        name: "educator-room-add",
        meta: { title: "创建班级" },
        component: () => import("@/views/educator/room/AddUpdateRoom.vue"),
      },
      {
        path: "room/edit",
        name: "educator-room-edit",
        meta: { title: "编辑班级" },
        component: () => import("@/views/educator/room/AddUpdateRoom.vue"),
      },
      {
        path: "room/detail",
        name: "educator-room-detail",
        meta: { title: "班级详情" },
        component: () => import("@/views/educator/room/RoomDetail.vue"),
      },
      {
        path: "course/add",
        name: "educator-course-add",
        meta: { title: "创建课程" },
        component: () => import("@/views/educator/course/AddUpdateCourse.vue"),
      },
      {
        path: "course/edit",
        name: "educator-course-edit",
        meta: { title: "编辑课程" },
        component: () => import("@/views/educator/course/CourseEdit.vue"),
      },
      {
        path: "course/detail",
        name: "educator-course-detail",
        meta: { title: "课程详情" },
        component: () => import("@/views/educator/course/CourseDetail.vue"),
      },
      {
        path: "lesson/detail",
        name: "educator-lesson-detail",
        meta: { title: "视频详情" },
        component: () => import("@/views/educator/course/LessonDetail.vue"),
      },
      {
        path: "course",
        name: "educator-course-list",
        meta: { title: "课程管理" },
        component: () => import("@/views/educator/course/CourseList.vue"),
      },

      // 数据标注
      {
        name: `${prefix}-train-ocean`,
        path: "tool/train-ocean",
        meta: { title: "海洋工程" },
        component: () => import("@/views/tools/training/TrainOcean.vue"),
      },
      {
        name: `${prefix}-training`,
        path: "tool/training",
        meta: { title: "数据标注" },
        component: () => import("@/views/tools/training/Training.vue"),
      },

      {
        name: "educator-works",
        path: "works",
        meta: { title: "资源库" },
        component: () => import("@/views/educator/MyWorks.vue"),
      },
      {
        name: "educator-resource",
        path: "resource",
        meta: { title: "资源库" },
        component: () => import("@/views/educator/course/ResourceList.vue"),
      },
      {
        name: "educator-train-model",
        path: "train-model",
        meta: { title: "AI体验" },
        component: () => import("@/views/tools/training/TrainModel.vue"),
      },
      {
        name: "educator-agent-hub",
        path: "agent-hub",
        meta: { title: "AI智能体" },
        component: () => import("@/views/educator/AgentHub.vue"),
      },
      {
        name: "educator-agent",
        path: "agent",
        meta: { title: "我的智能体" },
        component: () => import("@/views/educator/agent/AgentList.vue"),
      },
      {
        name: "educator-agent-add",
        path: "agent/add",
        meta: { title: "创建智能体" },
        component: () => import("@/views/educator/agent/AddUpdateAgent.vue"),
      },
      {
        name: "educator-agent-edit",
        path: "agent/edit",
        meta: { title: "编辑智能体" },
        component: () => import("@/views/educator/agent/AddUpdateAgent.vue"),
      },
      {
        name: "educator-student-records",
        path: "student-records",
        meta: { title: "学生学习记录" },
        component: () => import("@/views/educator/StudentRecords.vue"),
      },
      {
        name: "educator-teaching-resource",
        path: "teaching-resource",
        meta: { title: "教学资源" },
        component: () => import("@/views/educator/TeachingResource.vue"),
      },
    ],
  },
];
